import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import './PrincipalSearchCustomers.css'
import {
  agregarCliente,
  // agregarSucursal,
  cotizacionRemoveClient,
  quitarDireccion,
} from '../../../redux/actions/cotizacionActions.js'
import SearchCustomer from '../../SearchCustomer'
import ModalCustomerCounted from 'Components/ModalCustomerCounted'
import { fetchDeleteCustomer } from 'redux/actions/clientsActions'

const PrincipalSearchCustomers = ({
  handleModal,
  setClienteCotizacion,
  resetAddressStatus,
  setDefaultWarehouseToQuotation,
  onSuccessUpdateClient,
}) => {
  const [registers] = useState(null)
  const pageSize = 5
  const pageNums = []
  const totalPages = Math.ceil(registers / pageSize)
  for (let i = 1; i <= totalPages; i++) {
    pageNums.push(i)
  }

  const [clientSelectedDelete] = useState('')
  const [confirmDeleteClient, setConfirmDeleteClient] = useState(false)
  const dispatch = useDispatch()

  const [showModalClienteContado, setShowModalClienteContado] = useState(false)
  const [infoCustomerCounted, setInfoCustomerCounted] = useState({
    names: '',
    email: '',
    phone: '',
  })

  const addCustomerCounted = () => {
    resetAddressStatus()
    dispatch(cotizacionRemoveClient())
    dispatch(quitarDireccion())
    clienteSelect(null, null, infoCustomerCounted, null, null)
    dispatch(
      agregarCliente({
        id: null,
        customerType: null,
        customerName: infoCustomerCounted.names,
        customerEmail: infoCustomerCounted.email,
        customerPhone: infoCustomerCounted.phone,
        correo: null,
        externalCode: null,
        priceListId: null,
      })
    )
    handleModal(false)
  }

  const deleteCustomer = async () => {
    const Data = await dispatch(fetchDeleteCustomer(clientSelectedDelete))
    if (Data && Data?.CustomerInfo) {
      setConfirmDeleteClient(false)
    } else {
      throw new Error(Data)
    }
  }

  useEffect(() => {
    if (confirmDeleteClient) {
      deleteCustomer()
    }
  }, [confirmDeleteClient])

  const clienteSelect = (id, customerType, customer, externalCode) => {
    resetAddressStatus()
    const customerName = customer.names
    const customerEmail = customer.email
    const customerPhone = customer.phone

    dispatch(
      agregarCliente({
        id,
        customerType,
        customerName,
        customerEmail,
        customerPhone,
        externalCode,
      })
    )
    setClienteCotizacion({
      CustomerInfo: {
        FirstName: customerName,
        Email: customerEmail,
      },
    })
  }
  return (
    <>
      <SearchCustomer
        inModal={true}
        setShowModalClienteContado={setShowModalClienteContado}
        setClienteCotizacion={setClienteCotizacion}
        handleModal={handleModal}
        resetAddressStatus={resetAddressStatus}
        setDefaultWarehouseToQuotation={setDefaultWarehouseToQuotation}
        onSuccessUpdateClient={onSuccessUpdateClient}
      />

      <ModalCustomerCounted
        showModalCustomerCounted={showModalClienteContado}
        setShowModalCustomerCounted={setShowModalClienteContado}
        infoCustomerCounted={infoCustomerCounted}
        setInfoCustomerCounted={setInfoCustomerCounted}
        addCustomerCounted={addCustomerCounted}
      />
    </>
  )
}

export default PrincipalSearchCustomers
